export default {
  placeholder: 'Stahlsortengruppe auswählen',
};
